import { t } from 'i18next';
import NotificationBadge from './NotificationBadge';

const MyPageHeader = () => {
  return (
    <header className="py-[11px] flex items-center justify-between">
      <h1 className="text-[26px] font-bold text-main-light-1 dark:text-main-dark-1">
        {t('myPage.pageName')}
      </h1>
      <NotificationBadge />
    </header>
  );
};

export default MyPageHeader;
